export enum OrganizationType {
  Backoffice = 'Backoffice',
  NLH = 'NLH',
  Coach = 'Coach',
  Executive = 'Executive',
}
